import { Suspense, useState } from 'react';
import styled from 'styled-components';
import AppLoader from 'core/ui/components/AppLoader';
import { useTemplateEditorState } from '../context/UseTemplateEditorContext';
import { TemplateEditorTabs } from '../constants';
import { TemplateEditorView, NotificationProps } from './editor-tabs/left/template-editor/TemplateEditorView';
import { LinkConfigView } from './editor-tabs/left/link-config/LinkConfigView';
import { SnapshotEditorView } from './editor-tabs/left/snapshot-editor/SnapshotEditorView';
import { SnapshotSelectorView } from './editor-tabs/left/snapshot-selector/SnapshotSelectorView';
import { TemplateHistoryView } from './editor-tabs/left/history/TemplateHistoryView';

const LeftWindowWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  flex-shrink: 1;
`;

export const TemplateEditorLeftWindow = () => {
  const { activeLeftTab } = useTemplateEditorState();
  const [templateViewState, setTemplateViewState] = useState(null);
  const [templateModel, setTemplateModel] = useState(null);
  const [notificationTriggered, setNotificationTriggered] = useState(false);

  const notificationProps: NotificationProps = {
    notificationTriggered,
    setNotificationTriggered,
  };

  return (
    <Suspense fallback={<AppLoader />}>
      <LeftWindowWrapper data-testid="TemplateEditorLeftWindow">
        {activeLeftTab === TemplateEditorTabs.templateInput && (
          <TemplateEditorView
            model={templateModel}
            viewState={templateViewState}
            onChange={(model, viewState) => {
              setTemplateModel(model);
              setTemplateViewState(viewState);
            }}
            {...notificationProps}
          />
        )}
        {activeLeftTab === TemplateEditorTabs.compilationContextInput && <SnapshotEditorView />}
        {activeLeftTab === TemplateEditorTabs.linkConfig && <LinkConfigView />}
        {activeLeftTab === TemplateEditorTabs.compilationContextListInput && <SnapshotSelectorView />}
        {activeLeftTab === TemplateEditorTabs.templateHistory && <TemplateHistoryView />}
      </LeftWindowWrapper>
    </Suspense>
  );
};
